/* KRYSTO · Édition Halloween — passe tout le site en mode nuit d'Halloween.
   1) Repeint les fonds clairs (cartes, encarts, boutons blancs) en violet nuit, en gardant la teinte de la saveur.
   2) Passe les textes foncés en blanc os quand ils se retrouvent sur fond sombre.
   3) Ajoute le décor : chauves-souris, toiles, citrouilles, fantômes, lune. */
(function () {
  if (window.kxHw) return;
  window.kxHw = true;

  var BONE = '245, 239, 230';
  // Zones laissées telles quelles : décor, en-tête blanc, logo du pied de page
  var HORS = '.kx-hw-deco, .kx-header__bar, .kx-footer__logo';
  var SKIP = { IMG: 1, VIDEO: 1, PICTURE: 1, IFRAME: 1, CANVAS: 1, SOURCE: 1, SCRIPT: 1, STYLE: 1, LINK: 1, META: 1, NOSCRIPT: 1, BR: 1 };

  // ---------- Outils couleur ----------
  function parse(c) {
    var m = c && c.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(/[ ,\/]+/).filter(Boolean).map(parseFloat);
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }
  function lum(c) { // luminance relative
    function f(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b);
  }
  function hsl(c) {
    var r = c.r / 255, g = c.g / 255, b = c.b / 255, mx = Math.max(r, g, b), mn = Math.min(r, g, b), h = 0, s = 0, l = (mx + mn) / 2, d = mx - mn;
    if (d) {
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }
    return { h: h, s: s, l: l };
  }
  // Fond clair -> version nuit (garde la teinte des cartes saveur, violet pour le blanc/gris)
  function nuit(c) {
    var x = hsl(c);
    if (x.s < 0.12) return 'hsl(272, 32%, 16%)';
    return 'hsl(' + Math.round(x.h) + ', ' + Math.round(Math.min(x.s, 0.5) * 100) + '%, 15%)';
  }
  function fondEffectif(el) {
    while (el && el.nodeType === 1) {
      var cs = getComputedStyle(el);
      if (cs.backgroundImage && cs.backgroundImage !== 'none' && el.dataset.hwBg === undefined) return null; // dégradé/photo : inconnu
      var c = parse(cs.backgroundColor);
      if (c && c.a > 0.3) return c;
      el = el.parentElement;
    }
    return { r: 20, g: 14, b: 28, a: 1 };
  }

  // ---------- Repeint ----------
  function repeint(racine) {
    var els = racine.querySelectorAll ? [racine].concat([].slice.call(racine.querySelectorAll('*'))) : [];
    els.forEach(function (el) {
      if (SKIP[el.tagName] || el.closest(HORS)) return;
      var cs = getComputedStyle(el);

      // Fond clair -> nuit
      var bg = parse(cs.backgroundColor);
      if (bg && bg.a > 0.3 && cs.backgroundImage === 'none' && lum(bg) > 0.72) {
        el.style.setProperty('background-color', nuit(bg), 'important');
        el.dataset.hwBg = '1';
      }

      // Bordures noires -> trait os ; bordures grises -> discrètes
      if (parseFloat(cs.borderTopWidth) || parseFloat(cs.borderLeftWidth) || parseFloat(cs.borderBottomWidth)) {
        var bc = parse(cs.borderTopColor) || parse(cs.borderBottomColor);
        if (bc && bc.a > 0) {
          var bl = lum(bc), bs = hsl(bc).s;
          if (bl < 0.03) el.style.setProperty('border-color', 'rgba(' + BONE + ', .4)', 'important');
          else if (bs < 0.12 && bl > 0.3 && bl < 0.95) el.style.setProperty('border-color', 'rgba(' + BONE + ', .16)', 'important');
        }
      }
    });
    // Textes et pictos foncés sur fond sombre -> os (2e passe, une fois les fonds repeints)
    els.forEach(function (el) {
      if (SKIP[el.tagName] || el.closest(HORS)) return;
      var cs = getComputedStyle(el);
      var col = parse(cs.color);
      if (col && lum(col) < 0.06) {
        var f = fondEffectif(el);
        if (f && lum(f) < 0.25) el.style.setProperty('color', 'rgb(' + BONE + ')', 'important');
      }
      if (el instanceof SVGElement && el.tagName !== 'svg') {
        var fi = parse(cs.fill);
        if (fi && fi.a > 0 && lum(fi) < 0.03) {
          var f2 = fondEffectif(el.ownerSVGElement || el);
          if (f2 && lum(f2) < 0.25) el.style.setProperty('fill', 'rgb(' + BONE + ')', 'important');
        }
      }
    });
  }

  // ---------- Décor ----------
  var BAT = '<svg viewBox="0 0 100 46"><path fill="#6A4A93" d="M50 18C40 7 22 3 2 11c8 2 12 6 12 12 6-4 12-3 16 2 4-4 10-4 14 2l6 3 6-3c4-6 10-6 14-2 4-5 10-6 16-2 0-6 4-10 12-12C78 3 60 7 50 18z"/><path fill="#6A4A93" d="M44 16l-1-9 4 5h6l4-5-1 9c0 6-3 10-6 10s-6-4-6-10z"/><circle cx="47.5" cy="16" r="1.3" fill="#FF7A1A"/><circle cx="52.5" cy="16" r="1.3" fill="#FF7A1A"/></svg>';
  var SPIDER = '<svg viewBox="0 0 40 40"><g stroke="#6A4A93" stroke-width="2.4" stroke-linecap="round" fill="none"><path d="M16 18 6 10 3 16M16 22 4 22 2 28M17 25 8 32 8 38M24 18l10-8 3 6M24 22h12l2 6M23 25l9 7v6"/></g><ellipse cx="20" cy="23" rx="7" ry="8" fill="#6A4A93"/><circle cx="20" cy="14" r="5" fill="#6A4A93"/><circle cx="18" cy="13.5" r="1.4" fill="#8BD346"/><circle cx="22" cy="13.5" r="1.4" fill="#8BD346"/></svg>';
  var GHOST = '<svg viewBox="0 0 80 96"><path fill="#F5EFE6" d="M40 2C19 2 6 18 6 40v52l10-8 8 8 8-8 8 8 8-8 8 8 8-8 10 8V40C74 18 61 2 40 2z"/><ellipse cx="29" cy="38" rx="5" ry="7" fill="#161516"/><ellipse cx="51" cy="38" rx="5" ry="7" fill="#161516"/><ellipse cx="40" cy="56" rx="6" ry="8" fill="#161516"/><ellipse cx="20" cy="50" rx="5" ry="3" fill="#FFB3C7" opacity=".6"/><ellipse cx="60" cy="50" rx="5" ry="3" fill="#FFB3C7" opacity=".6"/></svg>';
  var PUMPKIN = '<svg viewBox="0 0 40 40"><path d="M19 10c-1-4 1-7 4-8l1 2c-2 1-3 3-2 6z" fill="#4CA83A"/><ellipse cx="12.5" cy="24" rx="9" ry="12" fill="#E35D0A"/><ellipse cx="27.5" cy="24" rx="9" ry="12" fill="#E35D0A"/><ellipse cx="20" cy="24" rx="9.5" ry="13" fill="#FF7A1A"/><path d="M13 21l3-3 3 3zM21 21l3-3 3 3zM13 27c3 4 11 4 14 0-2 1-3 1-4 1l-1-1-1 1h-2l-1-1-1 1c-1 0-2 0-4-1z" fill="#2A0F00"/></svg>';

  function deco(cls, html) {
    var d = document.createElement('div');
    d.className = 'kx-hw-deco ' + cls;
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML = html;
    return d;
  }

  function decor() {
    document.documentElement.classList.add('kx-hw');

    // Hero : slime, toile, araignée, chauves-souris
    var hero = document.querySelector('.kx-hero');
    if (hero && !hero.querySelector('.kx-hw-sky')) {
      var bats = '';
      for (var i = 1; i <= 4; i++) bats += '<span class="kx-hw-bat kx-hw-bat--' + i + '">' + BAT + '</span>';
      hero.insertBefore(deco('kx-hw-sky', '<i class="kx-hw-drip"></i><i class="kx-hw-web"></i><span class="kx-hw-spider"><i></i>' + SPIDER + '</span>' + bats), hero.firstChild);
    }

    // Fiche produit : lune derrière la canette + araignée
    var stage = document.querySelector('.kx-pdp__stage');
    if (stage && !stage.querySelector('.kx-hw-moon')) {
      stage.insertBefore(deco('kx-hw-moon', ''), stage.firstChild);
      stage.appendChild(deco('kx-hw-spider kx-hw-spider--pdp', '<i></i>' + SPIDER));
    }

    // Chaque section : toile, citrouilles ou fantôme, en alternance
    var secs = document.querySelectorAll('.kx:not(.kx-hero):not(.kx-ticker):not(.kx-header):not(.kx-cart):not(.kx-frband)');
    [].forEach.call(secs, function (s, n) {
      if (s.querySelector(':scope > .kx-hw-deco')) return;
      var k = n % 4;
      if (k === 0) s.appendChild(deco('kx-hw-web kx-hw-web--tl', ''));
      if (k === 1) s.appendChild(deco('kx-hw-pumpkins', '<span>' + PUMPKIN + '</span><span>' + PUMPKIN + '</span><span>' + PUMPKIN + '</span>'));
      if (k === 2) s.appendChild(deco('kx-hw-web kx-hw-web--tr', ''));
      if (k === 3) s.appendChild(deco('kx-hw-ghost', GHOST));
    });

    // Chauves-souris qui traversent l'écran de temps en temps, sur tout le site
    if (!document.querySelector('.kx-hw-night')) {
      document.body.appendChild(deco('kx-hw-night', '<span class="kx-hw-bat kx-hw-bat--a">' + BAT + '</span><span class="kx-hw-bat kx-hw-bat--b">' + BAT + '</span>'));
    }
  }

  function tout() {
    decor();
    document.querySelectorAll('.kx, .kx-cart, #kx-cart, .shopify-section').forEach(repeint);
  }

  // Le panier et les avis Judge.me se chargent après coup : on repeint ce qui arrive
  var attente = null, aRepeindre = [];
  function observe() {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && !n.classList.contains('kx-hw-deco')) aRepeindre.push(n); });
      });
      if (aRepeindre.length && !attente) attente = setTimeout(function () {
        var l = aRepeindre; aRepeindre = []; attente = null;
        l.forEach(function (n) { if (n.isConnected) repeint(n); });
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function go() { tout(); observe(); window.addEventListener('load', tout); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
